import React from "react";
import T from "prop-types";
import styled, { withTheme } from "styled-components";
import { media } from "@nested/ui";

const Bottom = ({ fillColour }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
    viewBox="0 0 1440 50"
  >
    <path
      fill={fillColour}
      d="M0,0 C240,33.3333333 480,50 720,50 C960,50 1200,33.3333333 1440,0 L1440,50 L0,50 L0,0 Z"
    />
  </svg>
);

Bottom.propTypes = {
  fillColour: T.string,
};

const Top = ({ fillColour }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
    viewBox="0 0 1440 50"
  >
    <path
      fill={fillColour}
      d="M0,50 L0,0 L1440,0 L1440,50 C1200,16.6666667 960,0 720,0 C480,0 240,16.6666667 0,50 Z"
    />
  </svg>
);

Top.propTypes = {
  fillColour: T.string,
};

const Wrapper = styled.div`
  background-color: transparent;
  z-index: 2;
  position: relative;
  width: 100%;
  height: 25px;

  ${media.tablet`
    height: 50px;
  `};

  svg {
    width: 100%;
    height: 100%;
  }
`;

const InvertedSwoosh = ({
  theme,
  className,
  position,
  children,
  colour = "white",
  shade = "medium",
}) => {
  const fillColour = theme.palette[colour][shade];
  return (
    <Wrapper position={position} className={className}>
      {position === "top" ? (
        <Top fillColour={fillColour} />
      ) : (
        <Bottom fillColour={fillColour} />
      )}
      {children}
    </Wrapper>
  );
};

InvertedSwoosh.propTypes = {
  children: T.node,
  className: T.string,
  position: T.string,
  theme: T.object.isRequired,
  colour: T.string,
  shade: T.string,
};

export default withTheme(InvertedSwoosh);
